import { useMemberId } from '@trello/authentication';

import { useEnterpriseAdminsFragment } from './EnterpriseAdminsFragment.generated';

export const useIsEnterpriseAdminMember = ({
  enterpriseId,
}: {
  enterpriseId: string | undefined;
}): { isAdmin: boolean } => {
  const memberId = useMemberId();

  const { data } = useEnterpriseAdminsFragment({
    from: { id: enterpriseId },
  });

  if (!data?.idAdmins) {
    return {
      isAdmin: false,
    };
  }
  return {
    isAdmin: data.idAdmins.includes(memberId),
  };
};
